import { Chart } from '@frontend/chart/types';

export const EQUIPMENT_STATE_ALL_LIST_CHART_MOCK_DATA: Chart = {
    series: [
        {
            name: 'equipment_in_use',
            data: [{ label: 'equipment_in_use', value: 8 }]
        },
        {
            name: 'equipment_available',
            data: [{ label: 'equipment_available', value: 100 }]
        },
        {
            name: 'equipment_unavailable',
            data: [{ label: 'equipment_unavailable', value: 10 }]
        }
    ]
};
